module.exports = __webpack_public_path__ + "img/gift5.49fbf635.png";